export default "__VITE_ASSET__BCuxkft5__"